<template>
  <div class="inputs">
    <input type="hidden" name="image" v-model="product.image"/>

    <div class="left-col">
      <div class="form-group row">
        <label class="col-3"
               for="name">Title
        </label>
        <div class="col-9">
          <input type="text"
                 name="name"
                 required
                 autocomplete="name"
                 v-model="product.name"
                 id="name"
                 maxlength="255"
                 class="form-control grey-input white"
          />
        </div>
        <div class="invalid-feedback"></div>
      </div>
      <div class="form-group row">
        <label class="col-3"
               for="description">Description
        </label>
        <div class="col-9">
                  <textarea type="text"
                            name="description"
                            required
                            autocomplete="description"
                            v-model="product.description"
                            id="description"
                            maxlength="255"
                            rows="10"
                            class="form-control grey-input white"
                  ></textarea>
        </div>
        <div class="invalid-feedback"></div>
      </div>

      <div class="form-group row">
        <label class="col-3"
               for="category_id">Category
        </label>
        <div class="col-9">
          <select class="form-control grey-input white"
                  id="category_id"
                  name="category_id"
                  required
                  v-model="product.category_id">
            <option v-for="category in categories"
                    :value="category.id">
              {{ category.name }}
            </option>
          </select>
        </div>
        <div class="invalid-feedback"></div>
      </div>

      <div class="form-group row">
        <label class="col-3"
               for="is_active">Is active
        </label>
        <div class="col-9">
          <select class="form-control grey-input white"
                  id="is_active"
                  name="is_active"
                  required
                  v-model="product.is_active">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3"
               for="available_in_au">Product available in Australia:
        </label>
        <div class="col-9">
          <select class="form-control grey-input white"
                  id="available_in_au"
                  name="available_in_au"
                  required
                  v-model="product.available_in_au">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-3"
               for="available_in_nz">Product available in New Zealand:
        </label>
        <div class="col-9">
          <select class="form-control grey-input white"
                  id="available_in_nz"
                  name="available_in_nz"
                  required
                  v-model="product.available_in_nz">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-3"
               for="sort_order">Display order in category
        </label>
        <div class="col-9">
          <input class="form-control grey-input white"
                 id="sort_order"
                 type="number"
                 name="sort_order"
                 min="0"
                 required
                 v-model="product.sort_order"
          />
        </div>
      </div>

      <div class="form-group row">
        <label for="mainImage" class="col-3">
          Main image
        </label>
        <div class="col-9">
          <input type="file"
                 style="display: none"
                 name="mainImage"
                 accept="image/*"
                 id="mainImage"
                 v-on:change="addFile($event)">
          <img :src="product.image"
               style="max-width: 200px;"
               alt=""
          />

          <button class="button button-primary-outline" type="button" @click="trigger">Change</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ProductInfoEditor",
  props: ['product', 'categories'],
  methods: {
    trigger(){
      $("#mainImage").click();
    },
    addFile(event) {
      let fileReader = new FileReader();

      let file = event.target.files[0];

      if (!file) {
        return
      }

      fileReader.addEventListener("load", () => {
        // convert image file to base64 string
        this.product.image = fileReader.result
      }, false);

      fileReader.readAsDataURL(file);

      $('#newImage')[0].file = null
    },
  }
}
</script>

<style scoped>

</style>
